import React from 'react'
import './Progress.scss'
import clsx from 'clsx'

interface ProgressProps {
  progress: number
  isSmall?: boolean
  placeholder?: string
  isTransparent?: boolean
  backgroundColor?: string
  className?: string
  ariaLabel?: string
}

export function Progress({
  progress,
  className,
  ariaLabel,
  placeholder,
  isSmall,
  backgroundColor,
  isTransparent
}: ProgressProps) {
  return (
    <div
      className={clsx(`progress-container ${isSmall ? 'small' : ''} ${isTransparent ? 'transparent' : ''}`, className)}
      style={{ backgroundColor }}
      role="progressbar"
      aria-label={ariaLabel}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(progress)}
    >
      <div className={`progress-fill ${isSmall ? 'small' : ''}`} style={{ width: `${progress}%` }} aria-hidden="true" />
      {placeholder && (
        <div className="progress-values">
          <span className="progress-value">{placeholder}</span>
        </div>
      )}
    </div>
  )
}
